import { getterTypes } from './types';

const getters = {
  [getterTypes.GET_APPLICATION]: (state) => state.catalog.application,
  [getterTypes.GET_LOCATION]: (state) => state.catalog.location,
  [getterTypes.GET_ROL]: (state) => state.catalog.rol,
  [getterTypes.GET_RESULT]: (state) => state.result.data,
  [getterTypes.GET_TABLE_CONFIG]: (state) => state.result.tableConfig,
  [getterTypes.GET_FILTER]: (state) => state.filter,
  [getterTypes.GET_CURRENT_FILTER]: (state) => state.currentFilter,
};

export default getters;
